<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <h2 style="margin: 0 8px 0 16px">月份</h2>
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 100px; margin-right: 8px"
          v-model="yearMonth"
          @on-change="changeYearMonth"
        />
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalCounts }}条</span>
          <!-- <Page :total="totalRows" :page-size="20" @on-change="loadReceive" show-total simple style="margin-right: 24px" /> -->
        </div>
        <Button type="success" :loading="exportReceiveTaskStatLoading" @click="exportReceiveTaskStat()">导出数据</Button>
        <Button type="success" :loading="setUserReceiveTaskLoading" @click="setUserReceiveTaskMethod()">统计回款任务</Button>
        <Button @click="notifyUserReceiveTaskWWMethod('sentToGroup')">发送任务至管理群</Button>
        <Button type="error" @click="notifyUserReceiveTaskWWMethod('sentToSales')">发送任务给业务员</Button>
      </div>
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="taskListParsed" :height="tableHeight" :loading="tableLoading" >
        <template slot-scope="{ row, column, index }" slot="receiveTask">
          <div style="display: flex; justify-content: space-between; height: 21px;">
            <div style="display: flex; align-items: baseline; gap: 2px; width: 85px;">
              <div style="font-size: 10px;">已回</div>
              <div style="font-weight: bold; color: green; width: 46px;">{{ row.receivedThisMonthDisplay }}</div>
            </div>
            <div style="display: flex; align-items: baseline; gap: 2px;">
              <div style="font-size: 10px;">剩余</div>
              <div style="font-weight: bold; width: 46px;">{{ row.leftReceiveTask }}</div>
            </div>
            

          </div>

          <div style="display: flex; align-items: baseline;" v-if="row.receiveTask">
            <div class="custom-progress-bar">
              <div class="custom-progress-bar-inside" :style="{width: row.taskFinishedPercentage}"></div>
            </div>
            <div style="width: 36px; font-size: 10px;">
              {{ row.taskFinishedPercentage }}
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { numberToWan } from "@/utils";
import dayjs from "dayjs";
import axios from "@/utils/axios";
import _ from "lodash";

export default {
  name: "ReceiveTaskStat",
  components: {  },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      tableLoading: false,
      limit: 99,
      page: 0,
      filterQuery: {},
      columns: [
        {
          title: "业务员",
          key: "user",
          width: 80,
          render: (h, params) => h("span", params.row.mainResponsible?.name || '公司客户'),
        },
        {
          title: "进度",
          key: "receivetask",
          width: 180,
          align: "right",
          slot: 'receiveTask'
        },
        {
          title: "本月回款",
          key: "receivetask",
          width: 90,
          align: "right",
          render: (h, params) =>
            h("span", params.row.receivedThisMonth?.toLocaleString('zh-CN', { maximumFractionDigits: 0 })),
        },
        {
          title: "回款任务",
          key: "receivetask",
          width: 90,
          align: "right",
          render: (h, params) =>
            h("span", params.row.receiveTask?.toLocaleString('zh-CN', { maximumFractionDigits: 0 })),
        },
        {
          title: "完成率",
          key: "receivetask",
          width: 90,
          align: "right",
          render: (h, params) =>
            h("span", params.row.taskFinishedPercentage),
        },
      ],
      yearMonth: null,
      setUserReceiveTaskLoading: false,
      exportReceiveTaskStatLoading: false,
    };
  },
  computed: {
    ...mapState({
      totalCounts: (state) => state.task.totalCounts,
      taskList: (state) => state.task.taskList,
      currentUser: (state) => state.auth.currentUser,
      companyList: (state) => state.company.companyList,
      simpleUserList: (state) => state.user.simpleUserList,
    }),
    taskListParsed: function () {
      const parsedData = [];
      for (const task of this.taskList) {
        
        let receivedThisMonth = '-';
        if (task.receivedThisMonth) receivedThisMonth = (task.receivedThisMonth/10000).toFixed(1) + 'w';
        let leftReceiveTask = '-';
        let taskFinishedPercentage = '0';
        if (task.receiveTask) {
          const leftAmount = task.receiveTask - (task.receivedThisMonth || 0);
          if (leftAmount > 0) {
            leftReceiveTask = (leftAmount/10000).toFixed(1) + 'w';
            taskFinishedPercentage = `${(task.receivedThisMonth / task.receiveTask * 100).toFixed(0)}%`;
          } else {
            taskFinishedPercentage = '100%';
          }

        }
        parsedData.push({
          ...task,
          receivedThisMonthDisplay: receivedThisMonth,
          leftReceiveTask,
          taskFinishedPercentage
        })
      }
      return parsedData;
    }
  },
  methods: {
    ...mapActions({
      getUserReceiveTask: "task/getUserReceiveTaskAction",
      setUserReceiveTask: "task/setUserReceiveTaskAction",
      notifyUserReceiveTaskWW: "task/notifyUserReceiveTaskWWAction",
      getSimpleUserList: "user/getSimpleUserListAction",
    }),
    async changeYearMonth() {
      const date = dayjs(this.yearMonth).format('YYYY-M').split('-')
      this.filterQuery.year = date[0]
      this.filterQuery.month = date[1]
      this.loadTask()
    },
    async setUserReceiveTaskMethod() {
      try {
        this.setUserReceiveTaskLoading = true;
        await this.setUserReceiveTask(this.filterQuery);
        this.setUserReceiveTaskLoading = false;
      } catch (error) {
        this.setUserReceiveTaskLoading = false;
        this.$Message.error(error);
      }
    },
    async notifyUserReceiveTaskWWMethod(sentTo) {
      const uploadData = this.filterQuery;
      if (sentTo === 'sentToSales') uploadData.sentToSales = true;
      if (sentTo === 'sentToGroup') uploadData.sentToGroup = true;
      try {
        this.setUserReceiveTaskLoading = true;
        await this.notifyUserReceiveTaskWW(uploadData);
        this.setUserReceiveTaskLoading = false;
      } catch (error) {
        this.setUserReceiveTaskLoading = false;
        this.$Message.error(error);
      }
    },
    async loadTask() {
      const query = {
        ...this.filterQuery,
        type: 'MonthlyReceiveTask'
      };
      try {
        this.tableLoading = true;
        await this.getUserReceiveTask(query);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadReceive();
    }, 1000),
    async exportReceiveTaskStat() {
      this.exportReceiveTaskStatLoading = true
      const textArray = dayjs(this.yearMonth).format('YYYY-M').split('-')
      const queryData = {}
      queryData.year = textArray[0]
      queryData.month = textArray[1]
      try {
        const res = await axios.get(`/export_receive_task_stat_table`, {
          responseType: "blob",
          params: queryData,
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `回款任务统计${dayjs().format("MM-DD-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        this.$Message.success("导出成功!");
      } catch (error) {
        this.$Message.error({
          content: `导出失败!${error}`,
          closable: true,
          duration: 0,
        });
      }
      this.exportReceiveTaskStatLoading = false
    },
  },
  async created() {
    // await this.getSimpleUserList({ limit: 99 });
    // await this.getSimpleBankAccount({ limit: 99 });
    // await this.getCompanyList({ limit: 99 });

    let query = this.$route.query;
    if (query.month && query.year) {
      this.filterQuery.month = query.month;
      this.filterQuery.year = query.year;
      this.yearMonth = query.year + "-" + query.month;
    } else {
      this.yearMonth = dayjs().format("YYYY-M");
      this.filterQuery.year = dayjs().year();
      this.filterQuery.month = dayjs().month() + 1;
    }
    this.loadTask();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .refresh
    cursor pointer

  .handle-right
    display flex
    align-items center
    gap 12px

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)
  display flex
  justify-content center

.custom-progress-bar
  width 100%
  border-radius 30px;
  height 4px
  background-color red

.custom-progress-bar-inside
  border-radius 30px;
  height 4px
  background-color rgb(66, 185, 131)
</style>